/*
 * Voyado product page — fires the Elevate Product Page query and exposes
 * window.VoyadoProductPage.notifyAddToCart() for the PDP add handlers.
 * Config: [data-main-product][data-voyado-product-key] + [data-product-json].
 */
;(function () {
  'use strict';

  var root = document.querySelector('[data-main-product][data-voyado-product-key]');
  if (!root) return;

  var productKey = root.getAttribute('data-voyado-product-key');
  if (!productKey) return;

  // tickets map is keyed by SKU; an add only knows the variant id.
  var skuByVariantId = {};
  try {
    var jsonEl = root.querySelector('[data-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var variants = (data && data.variants) || [];
    variants.forEach(function (v) {
      if (v && v.id != null && v.sku) skuByVariantId[String(v.id)] = v.sku;
    });
  } catch (e) { /* malformed JSON → empty map → notify no-ops */ }

  var ticketByVariantId = {};

  function currentTicket() {
    var input = root.querySelector('[data-variant-id]');
    var vid = input && input.value;
    return (vid && ticketByVariantId[String(vid)]) || '';
  }

  window.VoyadoProductPage = {
    notifyAddToCart: function () {
      if (window.VoyadoClient && typeof window.VoyadoClient.notifyAddToCart === 'function') {
        window.VoyadoClient.notifyAddToCart(currentTicket());
      }
    }
  };

  function loadTickets() {
    if (!window.VoyadoClient || typeof window.VoyadoClient.productPage !== 'function') return;
    window.VoyadoClient.productPage({ productKey: productKey, presentCustom: 'swatch_image_url|product_badges|colour_name' })
      .then(function (res) {
        var tickets = (res && res.tickets) || {};
        Object.keys(skuByVariantId).forEach(function (vid) {
          var t = tickets[skuByVariantId[vid]];
          if (t) ticketByVariantId[vid] = t;
        });
      })
      .catch(function () { /* query failed → map stays empty → notify no-ops */ });
  }

  // DOMContentLoaded fires after the deferred global voyado-client.js.
  if (document.readyState === 'complete') loadTickets();
  else document.addEventListener('DOMContentLoaded', loadTickets);
})();
